import {ACTIONS} from './constants';

export type Action = {type: typeof ACTIONS.UPDATE; progress: number};

export type State = {
	message: string;
	progress: number;
	working: boolean;
};

export const initialState: State = {
	message: '',
	progress: 0,
	working: false,
};

const reducer = (state: State, action: Action) => {
	switch (action.type) {
		case ACTIONS.UPDATE: {
			return {
				...state,
				progress: action.progress,
				working: action.progress > 0 && action.progress < 100,
			};
		}
	}
};

export default reducer;
